var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage, useIntl } from 'react-intl';
import getIcon from '../../../../utils/getIcon';
import { Notification } from '../../../../Notification';
import { formatCurrency } from '../../../../FormattedCurrency';
import { useInstallmentCalculatorContext } from '../../../Context';
var PriceInputWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var InstallmentInputLabel = styled.label(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  ", "\n"], ["\n  cursor: pointer;\n  ",
    "\n"])), function (_a) {
    var calculatorType = _a.calculatorType;
    return calculatorType === 'DYNAMIC' &&
        'display: block; width: 100%; text-align: center; font-size: 0.938rem;';
});
var InstallmentInputIconLabel = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: absolute;\n  cursor: pointer;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n"], ["\n  position: absolute;\n  cursor: pointer;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%);\n"])));
var InstallmentInputWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 11rem;\n  position: relative;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 11rem;\n  position: relative;\n"])));
var InstallmentInput = styled.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding: 0.333em 1rem;\n  text-align: center;\n  background: 0;\n  outline: none;\n  width: 100%;\n  ", "\n  &#installment-calculator-price {\n    border: 0;\n  }\n  &:focus {\n    background: #ffffff;\n  }\n"], ["\n  padding: 0.333em 1rem;\n  text-align: center;\n  background: 0;\n  outline: none;\n  width: 100%;\n  ",
    "\n  &#installment-calculator-price {\n    border: 0;\n  }\n  &:focus {\n    background: #ffffff;\n  }\n"])), function (_a) {
    var calculatorType = _a.calculatorType, hasSmallPrize = _a.hasSmallPrize;
    return calculatorType === 'DYNAMIC' && !hasSmallPrize ? 'font-size: 1.5rem;' : 'font-size: 0.9375rem;';
});
var validateInputVal = function (value) {
    var regExp = /^([\d]{1,2}([.]))?(\d{2,3})([,.]{1})(\d{2})(\s{1})(\D{1,3})$/g;
    var matches = value.match(regExp);
    return matches !== null ? matches.join('') : '';
};
export var InstallmentPriceInput = function () {
    var _a = useInstallmentCalculatorContext(), response = _a.response, isPriceEditable = _a.isPriceEditable, installmentPrice = _a.installmentPrice, setInstallmentPrice = _a.setInstallmentPrice, isSmallPrize = _a.config.isSmallPrize;
    var Pencil = getIcon('Edit');
    var _b = useState(isPriceEditable), showIcon = _b[0], setShowIcon = _b[1];
    var _c = useState(installmentPrice), inputVal = _c[0], setInputVal = _c[1];
    var _d = useState(false), isInputInvalid = _d[0], setIsInputInvalid = _d[1];
    var inputRef = useRef();
    var intl = useIntl();
    if (!response) {
        return null;
    }
    var currency = response.currency, type = response.type;
    var validationHint = (React.createElement("span", null,
        React.createElement("span", null,
            React.createElement(FormattedMessage, { id: "installment-calculator.validation.label", defaultMessage: "Bitte gib den Preis in folgendem Format an:" })),
        React.createElement("span", null, "\u00A0"),
        React.createElement("strong", null,
            React.createElement(FormattedMessage, { id: "installment-calculator.validation.pattern", defaultMessage: "X.XXX,XX \u20AC" }))));
    return (React.createElement(PriceInputWrapper, { "data-testid": "installment-price-input" },
        isInputInvalid && (React.createElement(Notification, { content: validationHint, isInline: true, level: "error", onClose: function () { return setTimeout(function () { return setIsInputInvalid(false); }, 400); } })),
        React.createElement(InstallmentInputLabel, { calculatorType: type, htmlFor: "installment-calculator-price" },
            React.createElement(FormattedMessage, { id: "installment-calculator.label.price", defaultMessage: "Preis" })),
        React.createElement(InstallmentInputWrapper, { calculatorType: type },
            React.createElement(InstallmentInput, { calculatorType: type, "data-testid": "price-input", defaultValue: formatCurrency(currency, inputVal, intl), disabled: !isPriceEditable, hasSmallPrize: isSmallPrize, id: "installment-calculator-price", name: "price", onBlur: function () {
                    setShowIcon(true);
                    var validatedInputVal = validateInputVal(inputRef.current ? inputRef.current.value : '');
                    var input = inputRef;
                    if (validatedInputVal === null) {
                        setIsInputInvalid(true);
                        if (input.current) {
                            input.current.value = inputVal.toString(10);
                        }
                    }
                    else {
                        setIsInputInvalid(false);
                        var value = Number(validatedInputVal
                            .replace('.', '')
                            .replace(',', '')
                            .replace(' ', '')
                            .replace('€', ''));
                        setInstallmentPrice(value);
                        if (input.current) {
                            input.current.value = validatedInputVal;
                        }
                    }
                }, onFocus: function () {
                    setShowIcon(false);
                    setInputVal(Number(inputRef.current && inputRef.current.value));
                }, onKeyPress: function (e) { return e.which === 13 && e.currentTarget.blur(); }, ref: inputRef, type: "text" }),
            isPriceEditable && showIcon && (React.createElement(InstallmentInputIconLabel, { "data-testid": "edit-icon", htmlFor: "installment-calculator-price" },
                React.createElement(Pencil, { size: "1.25rem" }))))));
};
export default InstallmentPriceInput;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=index.js.map